export const fmtEUR = (n) => {
  if (n == null || isNaN(n)) return "€ 0,00";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(n);
};

export const fmtNumber = (n, digits = 2) => {
  if (n == null || isNaN(n)) return "0";
  return new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(n);
};

export const fmtPct = (n, digits = 2) => {
  if (n == null || isNaN(n)) return "0%";
  return `${(n * 100).toFixed(digits).replace(".", ",")}%`;
};
